app.directive('heightConverter', function($window, $document, throttle) {
    return {
        restrict: 'A',
        scope: {
            from: '@from'
        },
        link: function($scope, $element) {
            if ($scope.from == 'view-customer') {
                const $heightContainer = $element.find('#height-text');
                const height = parseFloat($heightContainer.attr('data-height'));
                if (!height) {
                    return;
                }

                if ($element.find('select').val() == 'ft') {
                    const netHeight = Math.floor(height);
                    const netInchHeight = Math.round((height - Math.floor(height)) * 12);
                    let displayHeight = netHeight + "'" + (netInchHeight?netInchHeight+'"':'');
                    $heightContainer.text(displayHeight);
                }
                $element.find('select').on('change', function(e) {
                    const selectedUnit = e.target.value;
                    const previousUnit = e.target.dataset.unit || '';
    
                    if (!selectedUnit || selectedUnit === previousUnit) {
                        return;
                    }
    
                    const ratio = selectedUnit.toLowerCase() === 'ft' ? 0.0328084 : 30.48;
                    const currentHeight = $heightContainer.attr('data-height');

                    const convertedWeight = Math.round(currentHeight * ratio * 100) / 100;

                    if ($element.find('select').val() == 'ft') {
                        const netHeight = Math.floor(convertedWeight);
                        const netInchHeight = Math.round((convertedWeight - Math.floor(convertedWeight)) * 12);
                        let displayHeight = netHeight + "'" + (netInchHeight?netInchHeight+'"':'');
                        $heightContainer.text(displayHeight);
                    } else {
                        $heightContainer.text(convertedWeight);
                    }
                    $heightContainer.attr('data-height', convertedWeight);
                    e.target.dataset.unit = selectedUnit;
                });
            } else {
                const $heightInput = $element.parents('form').find('#profile_edit_heightInPreferredUnit');
                const $heightInchInput = $element.parents('form').find('#profile_edit_heightInInch');
    
                if (!$heightInput.length) {
                    return;
                }
    
                $heightInput.parent().append('<div class="sg-height-input-unit-placeholder"></div>');
                $heightInput.parent().addClass('sg-height-input');
                const $unitPlaceholder = $heightInput.parent().find('.sg-height-input-unit-placeholder');
                updateUnitPlaceholder($unitPlaceholder, $element.val());

                $heightInchInput.parent().append('<div class="sg-height-inch-input-unit-placeholder"></div>');
                $heightInchInput.parent().addClass('sg-height-input');
                const $unitInchPlaceholder = $heightInchInput.parent().find('.sg-height-inch-input-unit-placeholder');
                updateUnitPlaceholder($unitInchPlaceholder, 'IN');

                if ($element.val().toLowerCase() === 'cm') {
                    $heightInchInput.hide();
                    $heightInchInput.val('');
                }

                $element.on('change', function(e) {
                    const selectedUnit = e.target.value;
                    const previousUnit = e.target.dataset.unit || '';
    
                    if (!selectedUnit || selectedUnit === previousUnit) {
                        return;
                    }
    
                    const ratio = selectedUnit.toLowerCase() === 'ft' ? 0.0328084 : 30.48;
                    const currentHeight = $heightInput.val();
                    const currentInchHeight = $heightInchInput.val() * 0.0833333;
                    const totalHeight = parseFloat(currentHeight) + parseFloat(currentInchHeight);
                    
                    const convertedVal = Math.round(totalHeight * ratio * 100) / 100;

                    if (selectedUnit.toLowerCase() === 'ft') {
                        $heightInput.val(Math.floor(convertedVal));
                        $heightInchInput.val(Math.round((convertedVal-Math.floor(convertedVal)) * 12 * 100)/100);
                        $heightInchInput.show();
                    } else {
                        $heightInput.val(convertedVal);
                        $heightInchInput.hide();
                        $heightInchInput.val('');
                    }
                    e.target.dataset.unit = selectedUnit;

                    updateUnitPlaceholder($unitPlaceholder, e.target.value);
                });
            }
            
            function updateUnitPlaceholder($unitPlaceholder, value) {
                $unitPlaceholder.html(value);
            }
        }
    };
});
